import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import momentPropTypes from 'react-moment-proptypes';
import ProgressButtons from './ProgressButtons';
import CarrierSelectionSidebarContainer
  from '../../target-node-carrier-selector/containers/CarrierSelectionSidebarContainer';
import {
  getSelectedCarriers,
  getCheckedCarriers,
  getCarriers,
  getCarrierIsLoading,
} from '../../target-node-carrier-selector/redux/selectors/CarrierSelectors';
import SaveCarrierSelectionModal from '../../target-node-carrier-selector/components/SaveCarrierSelectionModal';
import { saveUserCarrierSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import CarrierSelector from '../../target-node-carrier-selector/components/CarrierSelector';
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from '../../period-selector/redux/selectors/PeriodSelectionSelectors';
import {
  carrierCheckedActionCreator,
  onDeSelectAllCarriers,
  onSelectAllCarriers,
  retrieveOutboundCarriersRequestActionCreator,
} from '../../target-node-carrier-selector/redux/actions/CarrierActions';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
/* eslint-disable import/no-cycle */
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import noop from '../../../../core/modules/common/tools/noop';

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundCarriersRequestActionCreator,
  saveUserCarrierSelectionRequestActionCreator,
  carrierCheckedActionCreator,
  onSelectAllCarriers,
  onDeSelectAllCarriers,
}, dispatch);

const mapStateToProps = state => ({
  selectedCarriersNodes: getSelectedCarriers(state),
  carriersNodes: getCarriers(state),
  checkedCarriers: getCheckedCarriers(state),
  carrierIsLoading: getCarrierIsLoading(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
});

// eslint-disable-next-line react/prefer-stateless-function
class TargetNodeCarrierWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstCarrier: true,
      selectionTreeLoaded: false,
      showOnlySelectedCarriers: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedCarriers: [],
      saveSelectionSelections: [],
    };
  }

  componentDidMount() {
    if (!this.props.carrierIsLoading) {
      this.props.retrieveOutboundCarriersRequestActionCreator({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      }, this.props.checkedCarriers);
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedCarriersNodes;
    // eslint-disable-next-line max-len
    if (this.state.firstCarrier && this.props.carriersNodes === nextProps.carriersNodes && nextProps.selectedCarriersNodes.length !== 0) {
      this.setState({
        firstCarrier: false,
        showOnlySelectedCarriers: true,
      });
    }

    await this.props.carriersNodes;
    this.setState({
      selectionTreeLoaded: this.props.carriersNodes.length > 0,
    });
  }

  componentDidUpdate(prevProps) {
    // Refetch when dates change
    const datesChanged = (
      !this.props.startDate.isSame(prevProps.startDate, 'day') ||
      !this.props.endDate.isSame(prevProps.endDate, 'day')
    );

    if (datesChanged) {
      this.props.retrieveOutboundCarriersRequestActionCreator({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      }, this.props.checkedCarriers);
    }
  }

  onSelectAllCarriers = () => {
    this.props.onSelectAllCarriers(this.props.carriersNodes);
  };

  onDeSelectAllCarriers = () => {
    this.setState({
      showOnlySelectedCarriers: false,
    });
    this.props.onDeSelectAllCarriers();
  };

  onSelectCarrier = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedCarriers: false,
      });
    } else {
      this.setState({
        firstCarrier: false,
      });
    }
    this.props.carrierCheckedActionCreator(selected);
  };

  onToggleShowOnlySelectedCarriers = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedCarriers: !this.state.showOnlySelectedCarriers,
    });
  };

  openSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedCarriers: this.props.checkedCarriers,
      saveSelectionSelections: this.props.selections,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedCarriers }) => {
    this.props.saveUserCarrierSelectionRequestActionCreator(
      name,
      checkedCarriers,
    );
    this.closeSaveSelectionModal();
  };

  render() {
    const tempNodes = [
      {
        value: 'DUMMY',
        label: 'LOADING...',
        expandDisabled: true,
        children: this.props.checkedCarriers && this.props.checkedCarriers.length > 0 ? this.props.checkedCarriers.map(initialItem => ({ value: initialItem, label: '', iataCode: '' })) : [],
      }];
    const carrierSelectorProps = {
      selected: this.props.checkedCarriers,
      // eslint-disable-next-line max-len
      isShowOnlySelected: !this.state.selectionTreeLoaded ? true : this.state.showOnlySelectedCarriers,
      // eslint-disable-next-line max-len,no-nested-ternary
      carrierNodes: !this.state.selectionTreeLoaded ? tempNodes : this.state.showOnlySelectedCarriers ?
        this.props.selectedCarriersNodes : this.props.carriersNodes,
      onSelect: !this.state.selectionTreeLoaded ? noop : this.onSelectCarrier,
      onSelectAll: !this.state.selectionTreeLoaded ? noop : this.onSelectAllCarriers,
      onDeSelectAll: !this.state.selectionTreeLoaded ? noop : this.onDeSelectAllCarriers,
      // eslint-disable-next-line max-len
      onShowOnlySelected: !this.state.selectionTreeLoaded ? noop : this.onToggleShowOnlySelectedCarriers,
      openSaveSelectionModal: !this.state.selectionTreeLoaded ? noop : this.openSaveSelectionModal,
    };

    const selectionCriteria = this.props.children.report.selectionCriteria.items;
    const SC_CODE = sc.SC090;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;
    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        {this.state.showSaveSelectionModal &&
        <SaveCarrierSelectionModal
          saveSelection={this.saveSelection}
          closeModal={this.closeSaveSelectionModal}
          checkedCarriers={this.state.saveSelectionCheckedCarriers}
          selections={this.state.saveSelectionSelections}
        />
        }
        <div className="operator-sidebar">
          <CarrierSelectionSidebarContainer
            report={this.props.children.report}
          />
        </div>

        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <CarrierSelector
                title="CARRIER"
                {...carrierSelectorProps}
              />
            </div>
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>
      </div>);
  }
}

TargetNodeCarrierWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  retrieveOutboundCarriersRequestActionCreator: PropTypes.func,
  selectedCarriersNodes: PropTypes.arrayOf(PropTypes.object),
  carriersNodes: PropTypes.arrayOf(PropTypes.object),
  checkedCarriers: PropTypes.arrayOf(PropTypes.string),
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    carriers: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  saveUserCarrierSelectionRequestActionCreator: PropTypes.func,
  carrierCheckedActionCreator: PropTypes.func,
  onSelectAllCarriers: PropTypes.func,
  onDeSelectAllCarriers: PropTypes.func,
  setDirections: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
};

/* Needed for prop-types with cloneElement */
export const ConnectedTargetNodeCarrierWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetNodeCarrierWizardContainer);

export default (ConnectedTargetNodeCarrierWizardContainer);
